import React from "react";
import PrintableAddForm from "@/components/PrintableAddForm";

/**
 * Blank IT-workstation audit form. Handed out to staff so they can walk
 * their desk and write down every bit of IT kit there — captured back in
 * the app by the manager afterwards. Fields cover the full workstation:
 * PC type, monitors, peripherals, mounting, and who uses it.
 */

const ROWS = [
  [
    { label: "Station name / desk label", flex: 3 },
    { label: "Department", flex: 2 },
  ],
  [
    { label: "Location on floor (bench, room, corner)", flex: 3 },
    { label: "Main user(s) at this station", flex: 3 },
  ],
  [
    { label: "PC type  [ ] Desktop   [ ] NUC   [ ] Laptop   [ ] USB PC   [ ] Other", flex: 5 },
    { label: "Make", flex: 2 },
    { label: "Model", flex: 2 },
  ],
  [
    { label: "Number of screens", flex: 1 },
    { label: "Screen 1 — make / size", flex: 2 },
    { label: "Screen 2 — make / size", flex: 2 },
    { label: "Screen 3+ — make / size", flex: 2 },
  ],
  [
    { label: "Monitor arm  [ ] Desk clamp   [ ] Drilled through   [ ] Freestanding   [ ] None", flex: 5 },
    { label: "Arm make / model", flex: 3 },
  ],
  [
    { label: "Keyboard — make / model", flex: 3 },
    { label: "  [ ] Wireless   [ ] Wired", flex: 2 },
  ],
  [
    { label: "Mouse — make / model", flex: 3 },
    { label: "  [ ] Wireless   [ ] Wired", flex: 2 },
  ],
  [
    { label: "Barcode scanner — make / model", flex: 3 },
    { label: "  [ ] Wireless   [ ] Wired   [ ] N/A", flex: 2 },
  ],
  [
    { label: "Docking station / hub — make / model", flex: 3 },
    { label: "Headset / phone — make / model", flex: 2 },
  ],
  [
    { label: "Printer at station — make / model (or shared?)", flex: 3 },
    { label: "Network — [ ] Ethernet   [ ] Wi-Fi", flex: 2 },
  ],
];

const ITStationAddPrint = () => (
  <PrintableAddForm
    pageTitle="IT station audit"
    toolbarHint="Hand this out to staff — one form per desk / workstation. Fill in every piece of IT kit at that station, then hand back to the manager to enter in the app."
    eyebrow="Podlab · IT audit"
    scope="IT audit"
    formTitle="Workstation audit sheet"
    rows={ROWS}
    starField={{ label: "PC serial number / asset tag" }}
    noteLabel="Notes · condition · anything unusual · faults · missing kit"
    testid="it-station-add-print-page"
    copies={2}
  />
);

export default ITStationAddPrint;
